import styled from "styled-components";

export const LegalDocumentLayout = styled.div`
`

export const LegalDocumentHeader = styled.div`
  display: flex;
  position: relative;
  flex-flow: column;
  align-items: center;
  gap: 64px;
  padding-top: 128px;
  padding-bottom: 64px;
  text-align: center;
  font-size: 12px;
  h1 {
    font-size: 1rem;
  }
  &::after{
    content: '';
    height: 1px;
    width: 100%;
    position: absolute;
    bottom: 0;
    // background: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, #FFF 50%, rgba(255, 255, 255, 0.00) 100%);
    background: ${({ theme }) => `linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, ${theme?.colors?.theme?.brandColor3} 50%, rgba(255, 255, 255, 0.00) 100%)`};
  }
`;

export const LegalDocumentFormat = styled.div`

  a {
    scroll-behavior: smooth;
    color: inherit;
    font-weight: 600;
    line-height: 2rem;
  }

  width: 100%;
  max-width: 600px;
  margin: 0 auto 32px auto;
  text-align: left;
  
  p {
    font-size: 1rem;
    line-height: 150%;
  }
  ul {
    padding-inline-start: 0.5rem;
  }
  li {
    margin: 16px;
    line-height: 150%;
    }
  h1 {
    margin-top: 48px;
    margin-bottom: 48px;
  }
  h2 {
    font-size: 1.5rem;
    text-transform: capitalize;
    margin-top: 48px;
    margin-bottom: 48px;
  }
  h3 {
    font-size: 1rem;
    text-transform: uppercase;
    margin-top: 32px;
    margin-bottom: 32px;
  }
`;